import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core'
import { AssetMini, AssetMiniFromJSON } from 'elements-sdk'

@Component({
  selector: 'video-thumbnail',
  template: `
    <img #strip [src]="url" />
  `,
  styleUrls: ['./videoThumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoThumbnailComponent {
  @Input() asset: AssetMini
  @Input() time = 0

  @ViewChild('strip', { 'static': false }) private strip?: ElementRef<HTMLImageElement>

  constructor (private elementRef: ElementRef<HTMLElement>) { }

  ngAfterViewInit () {
    this.strip?.nativeElement.addEventListener('load', () => {
      this.refresh()
    })
  }

  get url () {
    return this.asset.defaultProxy?.urls.strip ?? ''
  }

  ngOnChanges (changes) {
    if ('default_proxy' in this.asset) {
      this.asset = AssetMiniFromJSON(this.asset)
    }
    if (this.asset.type !== 'video') {
      throw new Error('Asset is not a video')
    }
    if (changes.time) {
      this.refresh()
    }
  }

  refresh () {
    if (!this.strip || this.time < 0) {
      return
    }
    const stripWidth = this.strip.nativeElement.width
    const thumbnailWidth = this.elementRef.nativeElement.clientWidth
    const thumbnailCount = Math.round(stripWidth / thumbnailWidth)
    const pc = this.time / this.asset.format.duration!
    const dx = Math.min(thumbnailCount - 1, Math.floor(stripWidth * pc / thumbnailWidth)) * thumbnailWidth
    this.strip.nativeElement.style.transform = `translate(${-dx}px, 0)`
  }
}
